// Centralised configuration for the backend API URL. Reads from Vite env vars first,
// falling back to production defaults so the app is still usable without a .env file.
export const API_BASE_URL =
  (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_API_BASE_URL) ||
  'https://api.roll2bowl.in/api';
  // 'http://localhost:8080/api';

export default {
  API_BASE_URL,
};
